/**
	* Number related tools
	* @module tools/misc
*/

/**
	* Round number to `places` decimal places
	* 
	* @param {number} num -	Number to round
	* @param {number} places - Amount of places to round to
*/
export function roundtodp(num:number, places:number):number {
	const multiplier = Math.pow(10, places || 0);
	return Math.floor(num * multiplier) / multiplier;
}

/**
	* Reverse number within range
	* 
	* @param {number} num - Number to reverse
	* @param {number} min - Minimum value
	* @param {number} max - Maximum value
*/
export function reverseNumber(num:number, min:number, max:number):number {
	return (max + min) - num;
}

/**
	* Reverse normal within 0 - 1 range
	* 
	* @param {number} num - Normalised number to reverse
*/
export function reverseNormal(num:number):number {
	return reverseNumber(num, 0, 1);
}

/**
	* Co-Ordinate Distance
	*
	* @param {Array<number>} coordinates A
	* @param {Array<number>} coordinates B
	* @returns Distance between two co-ordinates
*/
export function distanceCoords(coordsA:Array<number>, coordsB:Array<number>) {
	let x1:number = coordsA[0];
	let x2:number = coordsB[0];
	let y1:number = coordsA[1];
	let y2:number = coordsB[1];
	
	return Math.sqrt(Math.pow((x2-x1), 2) + Math.pow(y2-y1, 2));
}

/**
	* To precision function
	* 
	* @param {number} value
	* @param {number} precision
	* 
	* @returns {string} Precision number string
*/
export function toPrecision(value:number, precision:number):string {
	const factor = Math.pow(10, precision);
	return (Math.round(value * factor) / factor).toString();
}

/**
	* Get unix timestamp (seconds)
*/
export function time():number {
	return new Date().getTime() / 1000;
}